import {Component, Input, OnDestroy, ViewEncapsulation} from '@angular/core';
import { PanelsName } from 'app/enums/panels.enum';

@Component({
    selector     : 'no-data-card',
    templateUrl  : './no-data-card.component.html',
    styleUrls    : ['./no-data-card.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NoDataCardComponent implements OnDestroy {

    @Input() panel: string;
    panelNames = PanelsName;

    /**
     * Constructor
     */
    constructor(
    ) {
    }

    ngOnDestroy(): void {
    }
}
